import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";
import appdata, {
  appdata_setSnackbar,
  appdata_updateListValues,
  appdata_setError
} from "reducers/appdata/appdata";
import { provider_company_parts, provider_contact_parts, provider_bank_parts, provider_po_parts } from "./vendordataProvider";
import { redirectAndSaveState } from "services/auth";

const CancelToken = axios.CancelToken;
var source = CancelToken.source();

const parts = { COMPANY: provider_company_parts, CONTACT: provider_contact_parts, BANK: provider_bank_parts, PURCHASING: provider_po_parts };

export const initialState = {
  activeVendor: {},
  activeVendorStatic: {},
  sapVendor: {},
  incompleteRequiredFields: {},
  approvers: {},
  files: {},
  saving: false,
  savedToSAP: false,
  vendorParts: parts,
  loading: false,
  banks: {}
};

export const vendordataSlice = createSlice({
  name: "vendordata",
  initialState,
  reducers: {
    vendordata_updateincompleteRequiredFields: (state, action) => {
      let remove = action.payload.remove ? true : false;
      let id = action.payload.id ? action.payload.id : null;
      let part = action.payload.part;
      let field = action.payload.field;
      if (!state.incompleteRequiredFields.hasOwnProperty(part)) {
        state.incompleteRequiredFields[part] = {};
      }


      if (id) {
        if (remove) {

          console.log("shoud remove id", part, id, field)
          let index = state.incompleteRequiredFields[part][id].indexOf(field);
          state.incompleteRequiredFields[part][id].splice(index, 1);

          if (state.incompleteRequiredFields[part][id].length == 0) {
            //state.incompleteRequiredFields[part].splice(id, 1);
            delete state.incompleteRequiredFields[part][id];
          }

          if (state.incompleteRequiredFields[part].length == 0) {
            delete state.incompleteRequiredFields[part]
          }

        }
        else {
          console.log("complete add id", part, id, field)
          if (!state.incompleteRequiredFields[part].hasOwnProperty(id)) {
            state.incompleteRequiredFields[part][id] = [];
          }
          if (!state.incompleteRequiredFields[part][id].includes(field)) {
            console.log("typeof", typeof field);
            state.incompleteRequiredFields[part][id].push(field);
          }
        }
      }
      else {
        if (remove) {
          //let index = state.incompleteRequiredFields[part].indexOf(field);
          //state.incompleteRequiredFields[part].splice(index, 1);
          console.log("remove",part,field);
          delete state.incompleteRequiredFields[part][field];
          if (Object.keys(state.incompleteRequiredFields[part]).length == 0) {
            console.log("should remove part as well");

            delete state.incompleteRequiredFields[part];

          }
        }
        else {

          if (field && !state.incompleteRequiredFields[part].hasOwnProperty(field)) {
            console.log("should add",part,field);
            console.log("should add to",state.incompleteRequiredFields[part]);
            state.incompleteRequiredFields[part][field] = "1";
          }
        }
      }

    },
    vendordata_setBanksFromSearch: (state, action) => {
      state.banks = action.payload;
    },
    vendordata_setSaving: (state, action) => {
      state.saving = action.payload;
    },
    vendordata_setLoading: (state, action) => {
      state.loading = action.payload;
    },
    vendordata_setSavedToSAP: (state, action) => {
      state.savedToSAP = action.payload;
    },
    vendordata_setApprovers: (state, action) => {
      state.approvers = action.payload;
    },
    vendordata_clearAllVendorData: (state, action) => {
      state.activeVendor = {};
      state.sapVendor = {};
      state.activeVendorStatic = {};
      state.files = {};
      state.incompleteRequiredFields = {};
    },
    vendordata_updateActiveVendorStatic: (state, action) => {
      state.activeVendorStatic = state.activeVendor;
    },
    vendordata_updateActiveVendor: (state, action) => {
      let part = action.payload.part ? action.payload.part : null;
      let key = action.payload.key ? action.payload.key : null;
      let value = action.payload.value ? action.payload.value : null;
      let SAP = action.payload.SAP ? action.payload.SAP : false;
      let id = action.payload.id ? action.payload.id : false;


      let vendorToUse = SAP ? "sapVendor" : "activeVendor";

      if (!part) {
        console.error("can not update active vendor, part not given");
      }

      if (!key) {
        console.error("can not update active vendor, key not given");
      }

      // create part in active vendor if not set yet
      // this is for instance 'master'
      if (!state[vendorToUse][part]) {
        state[vendorToUse][part] = {};
      }

      if (id) {
        if (!state[vendorToUse][part][id]) {
          state[vendorToUse][part][id] = {};
        }
        let toUpdate = {
          ...state[vendorToUse][part][id]
        };

        toUpdate[key] = value;
        state[vendorToUse][part][id] = toUpdate;
      } else {
        let toUpdate = {
          ...state[vendorToUse][part]
        };

        toUpdate[key] = value;
        state[vendorToUse][part] = toUpdate;

      }

      state.savedToSAP = false;

    },
    vendordata_updateFiles: (state, action) => {
      console.log("update vendor files", action.payload);

      if (Object.keys(action.payload).includes("files")) {
        action.payload.files.map(file => {
          console.log("add file", file);
          state.files[Object.keys(state.files).length] = file;
          //state.files.push(JSON.stringify(file));
        });
      }

      if (action.payload.remove) {
        Object.keys(state.files).map(key => {
          if (parseInt(state.files[key].FILE_NUM) == parseInt(action.payload.FILE_NUM)) {
            state.files[key]['DELETE'] = "X";
          }

        })
      }
    }
  }
});

export const {
  vendordata_setSaving,
  vendordata_updateActiveVendor,
  vendordata_updateActiveVendorStatic,
  vendordata_clearAllVendorData,
  vendordata_updateFiles,
  vendordata_setSavedToSAP,
  vendordata_setApprovers,
  vendordata_updateincompleteRequiredFields,
  vendordata_setLoading,
  vendordata_setBanksFromSearch,
} = vendordataSlice.actions;
export const vendordataSelector = state => state.vendordata;
export default vendordataSlice.reducer;

export function vendor_save_to_sap() {
  console.log("save to sap");
  return async (dispatch, getState) => {
    console.log("something", getState());
    dispatch(vendordata_setSaving(true));
    dispatch(
      appdata_setSnackbar({
        open: true,
        message: "Saving...",
        severity: "info"
      })
    );

    source = CancelToken.source();

    const axiosConfig = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
      cancelToken: source.token
    };

    axios
      .post(
        APPCONFIG.appBackendHostname + "api/vendormasterdata/request/update",
        {
          vendor: getState().vendordata.activeVendor,
          vendorfiles: getState().vendordata.files,
          type: getState().appdata.activeRequestState,
          reqID: getState().appdata.activeRequestID,
          reqtype: getState().appdata.activeRequestType
        },
        axiosConfig
      )
      .then(res => {
        console.log("save succes", res);



        if (res.data.error) {
          console.log("got error");
          dispatch(
            appdata_setSnackbar({
              open: true,
              message: res.data.MESSAGE,
              severity: "error"
            })
          );
        } else {
          if (res.data.reqid) {
            dispatch(
              vendordata_updateActiveVendor({
                part: "master",
                key: "requestID",
                value: res.data.reqid
              })
            );
          }

          if (res.data.COMPANY) {
            Object.keys(res.data.COMPANY).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  part: "COMPANY",
                  key: key,
                  value: res.data.COMPANY[key]
                })
              );
            });
          }
          if (res.data.APPROVERS) {

            if (res.data.APPROVERS) {
              Object.keys(res.data.APPROVERS).map(key => {
                dispatch(
                  vendordata_setApprovers(res.data.APPROVERS)
                );
              });
            }
          }
          if (res.data.PURCHASING) {

            Object.keys(res.data.PURCHASING).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  part: "PURCHASING",
                  key: key,
                  value: res.data.PURCHASING[key]
                })
              );
            });
          }

          if (res.data.CONTACT) {

            Object.keys(res.data.CONTACT).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  part: "CONTACT",
                  key: key,
                  value: res.data.CONTACT[key]
                })
              );
            });
          }

          if (res.data.BANK) {

            Object.keys(res.data.BANK).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  part: "BANK",
                  key: key,
                  value: res.data.BANK[key]
                })
              );
            });
          }

          dispatch(vendordata_setSavedToSAP(true));

          dispatch(
            appdata_setSnackbar({
              open: true,
              message: "Saved",
              severity: "success"
            })
          );

        }

        dispatch(vendordata_setSaving(false));


      })
      .catch(error => {
        console.log("save failed", error);

        redirectAndSaveState(error);


        //reject(error);
        /*  dispatch(
           appdata_setSnackbar({
             open: true,
             message: error.message,
             severity: "error"
           })
         ); */

        dispatch(vendordata_setSaving(false));
      });
  };
}

export function vendordata_getVendorDataForRequest(requestID) {


  return async (dispatch, getState) => {
    if (getState().vendordata.loading) {
      source.cancel("Operation canceled by the user.");
    }

    source = CancelToken.source();
    dispatch(vendordata_setLoading(true));
    axios.defaults.withCredentials = true;
    axios
      .get(
        APPCONFIG.appBackendHostname +
        "api/vendormasterdata/request/" +
        requestID,
        {
          withCredentials: true,
          timeout: APPCONFIG.axiosTimeout,
          cancelToken: source.token
        }
      )
      .then(res => {
        console.log("got vendor for request", res);

        // clear vendor
        dispatch(vendordata_clearAllVendorData());

        // fill master data
        Object.keys(res.data.DESCRIPTION).map(key => {
          dispatch(
            vendordata_updateActiveVendor({
              part: "master",
              key: key,
              value: res.data.DESCRIPTION[key]
            })
          );
        });

        // fill company data (general)
        // fill company data (general)
        // fill company data (general)
        // fill company data (general)
        Object.keys(res.data.COMPANY).map(key => {
          dispatch(
            vendordata_updateActiveVendor({
              part: "COMPANY",
              key: key,
              value: res.data.COMPANY[key]
            })
          );
        });
        // fill company data (general) of sap vendor
        if (res.data.VENDORDATA_SAP) {
          Object.keys(res.data.VENDORDATA_SAP.COMPANY).map(key => {
            dispatch(
              vendordata_updateActiveVendor({
                SAP: true,
                part: "COMPANY",
                key: key,
                value: res.data.VENDORDATA_SAP.COMPANY[key]
              })
            );
          });
        }

        // fill contact data
        // fill contact data
        // fill contact data
        // fill contact data
        // if no contacts are found, create an empty one
        if (res.data.CONTACT && res.data.CONTACT.length == 0) {
          console.log("no contacts");
          dispatch(
            vendordata_updateActiveVendor({
              part: "CONTACT",
              key: "0",
              value: { SEQ: "0" }
            })
          );
        }
        else {
          Object.keys(res.data.CONTACT).map(key => {
            dispatch(
              vendordata_updateActiveVendor({
                part: "CONTACT",
                key: key,
                value: res.data.CONTACT[key]
              })
            );
          });
        }
        // fill contact data of sap 

        if (res.data.VENDORDATA_SAP) {
          if (res.data.VENDORDATA_SAP.CONTACT && res.data.VENDORDATA_SAP.CONTACT.length == 0) {
            console.log("no contacts");
            dispatch(
              vendordata_updateActiveVendor({
                SAP: true,
                part: "CONTACT",
                key: "0",
                value: { SEQ: "0" }
              })
            );
          }
          else {
            Object.keys(res.data.VENDORDATA_SAP.CONTACT).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  SAP: true,
                  part: "CONTACT",
                  key: key,
                  value: res.data.VENDORDATA_SAP.CONTACT[key]
                })
              );
            });
          }
        }

        // bank data
        // bank data
        // bank data
        // bank data
        // bank data
        // bank data
        if (res.data.BANK && res.data.BANK.length == 0) {
          console.log("no contacts");
          dispatch(
            vendordata_updateActiveVendor({
              part: "BANK",
              key: "0",
              value: { SEQ: "0" }
            })
          );
        }
        else {
          if (res.data.BANK) {
            console.log("got bank", res.data)
            Object.keys(res.data.BANK).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  part: "BANK",
                  key: key,
                  value: res.data.BANK[key]
                })
              );
            });
          }
        }

        if (res.data.VENDORDATA_SAP) {
          if (res.data.VENDORDATA_SAP.BANK && res.data.VENDORDATA_SAP.BANK.length == 0) {
            console.log("no contacts");
            dispatch(
              vendordata_updateActiveVendor({
                SAP: true,
                part: "BANK",
                key: "0",
                value: { SEQ: "0" }
              })
            );
          }
          else {
            Object.keys(res.data.VENDORDATA_SAP.BANK).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  SAP: true,
                  part: "BANK",
                  key: key,
                  value: res.data.VENDORDATA_SAP.BANK[key]
                })
              );
            });
          }
        }


        // purchasing
        // purchasing
        // purchasing
        // purchasing
        // purchasing
        // purchasing
        if (res.data.PURCHASING) {
          Object.keys(res.data.PURCHASING).map(key => {
            dispatch(
              vendordata_updateActiveVendor({
                part: "PURCHASING",
                key: key,
                value: res.data.PURCHASING[key]
              })
            );
          });
        }

        if (res.data.VENDORDATA_SAP) {
          Object.keys(res.data.VENDORDATA_SAP.PURCHASING).map(key => {
            dispatch(
              vendordata_updateActiveVendor({
                SAP: true,
                part: "PURCHASING",
                key: key,
                value: res.data.VENDORDATA_SAP.PURCHASING[key]
              })
            );
          });
        }





        // dropdowns specific for request
        dispatch(
          appdata_updateListValues({
            key: "reconAcct",
            value: res.data.DROPDOWNS.reconAcct
          })
        );

        dispatch(
          appdata_updateListValues({
            key: "paymentMethod",
            value: res.data.DROPDOWNS.paymentMethod
          })
        );

        // approvers
        dispatch(vendordata_setApprovers(res.data.APPROVERS));

        // fill files
        dispatch(vendordata_updateFiles({ files: res.data.FILEDATA }));

        dispatch(vendordata_updateActiveVendorStatic());

        dispatch(vendordata_setSavedToSAP(true));

        dispatch(vendordata_setLoading(false));

        // vendor SAP
        // vendor SAP
        // vendor SAP
        // vendor SAP

        /* Object.keys(res.data).map(key =>{
          console.log("key",key);
          // master
          if (key == "DESCRIPTION"){
            Object.keys(res.data[key]).map(innerkey => {
              dispatch(vendordata_updateActiveVendor({part:"master",key:innerkey,value:res.data[key][innerkey]}))
            })
          }
          // files
          if (key == "FILEDATA"){
            getState().files = res.data[key];
          }
        }) */

        //resolve(res);
      })
      .catch(error => {
        console.error(" error on result getting vendor", error);
        if (error.message != "Operation canceled by the user.") {
          /* dispatch(appdata_setError("Get request: " + error.message)); */
          dispatch(appdata_setSnackbar({ open: true, severity: "error", message: "Get request: " + error.message }));
        }
      });
  };
}

export function vendordata_getBankData(bankinfo) {
  return async (dispatch, getState) => {

    source = CancelToken.source();

    const axiosConfig = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
      cancelToken: source.token
    };

    return new Promise(function (resolve, reject) {
      axios
        .post(
          APPCONFIG.appBackendHostname + "api/vendormasterdata/bankinfo",
          {
            bankinfo: bankinfo
          },
          axiosConfig
        )
        .then(res => {
          //resolve(res.data);
          console.log("got bank s", res.data);

          if (res.data.banks == []) {
            //console.log("bank data received invalid bank");
            dispatch(appdata_setSnackbar({ open: true, severity: "error", message: "No bank found based on data" }))
            return;
          }

          if (res.data.banks.length == 0) {
            dispatch(appdata_setSnackbar({ open: true, severity: "error", message: "No bank found based on data" }))
          }
          
          dispatch(vendordata_setBanksFromSearch(res.data.banks))

          /*  if (getState().vendordata.activeVendor.BANK && Object.keys(getState().vendordata.activeVendor.BANK[0]).length > 1) {
             console.error("add bank to existing banks")
             let lastSeq = parseInt(getState().vendordata.activeVendor.BANK[Object.keys(getState().vendordata.activeVendor.BANK).length - 1]["SEQ"]);
             let newSeq = lastSeq + 1;
             let newBank = { ...res.data }
             newBank['SEQ'] = newSeq;
             newBank['REQ_ID'] = getState().appdata.activeRequestID;
             console.log("newBank", newBank);
 
             dispatch(
               vendordata_updateActiveVendor({
                 part: "BANK",
                 key: Object.keys(getState().vendordata.activeVendor.BANK).length,
                 value: newBank
               }))
 
           }
           else {
             console.log("add bank as new bank")
             let newBank = { ...res.data }
             newBank['SEQ'] = 0;
             newBank['REQ_ID'] = getState().appdata.activeRequestID;
             console.log("newBank", newBank);
 
             dispatch(
               vendordata_updateActiveVendor({
                 part: "BANK",
                 key: "0",
                 value: newBank
               }))
           } */


        })
        .catch(error => {
          console.error("got error on bank")
          dispatch(appdata_setSnackbar({ open: true, message: error.message, severity: "error" }))
          //reject(error);
        });
    });

  }
}

export function vendordata_updateApprovers(approver) {
  console.log("approve with approver", approver);
  return async (dispatch, getState) => {
    source = CancelToken.source();

    //console.log("update approvers");
    //console.log(approver);

    const axiosConfig = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
      cancelToken: source.token
    };


    axios
      .post(
        APPCONFIG.appBackendHostname + "api/vendormasterdata/approvers/update",
        {
          reqID: getState().appdata.activeRequestID,
          approver: approver
        },
        axiosConfig
      )
      .then(res => {
        //resolve(res.data);
        console.log("approved", res.data);
        if (res.data.error) {
          dispatch(appdata_setSnackbar({ open: true, message: res.data.MESSAGE, severity: "error" }))
        }
        else {
          if (res.data.MESSAGE) {
            dispatch(appdata_setSnackbar({ message: res.data.MESSAGE, open: true, severity: "success" }))
          }

          dispatch(vendordata_setApprovers(res.data.APPROVERS));



          // fill master data
          if (res.data.DESCRIPTION) {
            Object.keys(res.data.DESCRIPTION).map(key => {
              dispatch(
                vendordata_updateActiveVendor({
                  part: "master",
                  key: key,
                  value: res.data.DESCRIPTION[key]
                })
              );
            });
          }
        }
      })
      .catch(error => {
        console.error("error", error);
        console.log(error);
      });


  }
}
